import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { KYMW7003Model } from './kymw7003.model';
import { Router } from '@angular/router';
import { GetFeatureRequestStatusListService } from './api-services/get-feature-request-status-list.service';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { Menu } from '@grapecity/wijmo.input';
import { FlexGrid, CellType, CellRange } from '@grapecity/wijmo.grid';
import { FlexGridFilter } from '@grapecity/wijmo.grid.filter';
import { FeatureRequestInfo } from './vo/feature-request-info.model';

@Component({
  selector: 'app-kymw7003',
  templateUrl: './kymw7003.component.html',
  styleUrls: ['./kymw7003.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW7003Component extends PlessViewHelperSub implements OnInit {
  public model: KYMW7003Model = new KYMW7003Model();
  private contextForFeatureRequest: Menu;

  @ViewChild('dtg_FeatureRequestList', { static: true }) dtg_FeatureRequestList: FlexGrid;
  @ViewChild('flr_FeatureRequestList', { static: true }) flr_FeatureRequestList: FlexGridFilter;

  constructor(
    private dialogService: PlessDialogServiceSub,
    private getFeatureRequestStatusListService: GetFeatureRequestStatusListService,
    private kymw00Model: KYMW00Model,
    private router: Router,
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW7003Component
   */
  public ngOnInit(): void {
    let isTarget = false;
    if (this.kymw00Model.kymw1001Model.isSupplier()) {
      // ログインユーザが取引先の場合
      isTarget = true;
      this.model.userType = '1';
      this.model.payeeSupplierCode = this.kymw00Model.kymw1001Model.loginUserInfo.SupplierCode;
    } else if (this.kymw00Model.kymw1001Model.isPlanningSupport()) {
      // ログインユーザが企画支援の場合
      isTarget = true;
      this.model.userType = '2';
      this.model.associatedCompanyId = this.kymw00Model.kymw1001Model.loginUserInfo.SupplierCode;
    }

    if (isTarget) {
      // 初期表示用のAPIリクエスト
      this.getFeatureRequestStatusListService.execute(this.model, () => {
        // ステータスに表示する値の設定を行う
        this.model.featureRequestList.map(f => 
          f.SelectionFlag === 2 ? f.statusName = '提案済み' : f.statusName = '提案前'
        );
      });
    } else {
      // ログインユーザのユーザ区分が「取引先(卸)」「企画支援」以外の場合、
      // 「現在ログインしているユーザーでは特集商品提案状況の一覧を取得できません」を表示する
      this.dialogService.openAlertGetMessage('E0605', null, null);
    }

    // コンテキストメニュー設定
    this.createContextMenu();
  }

  /**
   * コンテキストメニュー 企画回特集確認・企画回特集履歴確認
   *
   * @memberof KYMW7004Component
   */
  private checkSpecialFFeature() {

    if (!(this.dtg_FeatureRequestList.selectedItems[0] instanceof FeatureRequestInfo)) return;
    const selFeatureRequest = this.dtg_FeatureRequestList.selectedItems[0];
    let ViewType = 0;

    // 特集商品選定画面を呼び出す
    // 遷移先でthis.router.getCurrentNavigation()を使用してstateの値を取得
    if (selFeatureRequest.statusName !=="提案前") {
      ViewType = 1;
    }

    const data = {
      CatalogIdName: selFeatureRequest.CatalogIdName,
      FeatureName: selFeatureRequest.FeatureName,
      mediumType: selFeatureRequest.MediumType,
      FeatureCode: selFeatureRequest.FeatureCode,
      ViewType: ViewType,
      OrderCode: selFeatureRequest.OrderCode,
      MediumName: selFeatureRequest.MediumName,
    };
    // 遷移先とパラメータを設定
    this.router.navigate(['/kymw/7002'], { queryParams: data });
  }

  /**
   * コンテキストメニュー作成
   *
   * @memberof KYMW7003Component
   */
  private createContextMenu(): void {
    this.contextForFeatureRequest = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [
        { caption: '商品提案', cmd: 'checkSuggestion', enabled: true },
        { caption: '履歴確認', cmd: 'checkSuggestionIdHistory', enabled: true },
      ],
      command: {
         canExecuteCommand: param => {
           return param.enabled === false ? false : true;
         },
      },
      itemClicked: () => {
        if (this.contextForFeatureRequest.selectedValue === 'checkSuggestion') this.checkSpecialFFeature();
        if (this.contextForFeatureRequest.selectedValue === 'checkSuggestionIdHistory') this.checkSpecialFFeature();
      },
    });

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_FeatureRequestList.hostElement.addEventListener('contextmenu', e => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextForFeatureRequest !== undefined) {
        const ht = this.dtg_FeatureRequestList.hitTest(e.pageX, e.pageY);
        if (ht.cellType === CellType.Cell) {
          // 右クリック押下時に対象行を選択状態にする
          const grid = new CellRange(ht.row, ht.col);
          this.dtg_FeatureRequestList.select(grid, false);
        }
        // コンテキストメニュー項目活性・非活性制御呼出
        this.eventContextMenu_Handler();
        // メニュー表示
        this.contextForFeatureRequest.show(e);
      }
    });
  }

  /**
   * コンテキストメニュー項目活性・非活性制御
   *
   * @memberof KYMW7003Component
   */
  private eventContextMenu_Handler(): any {
    this.contextForFeatureRequest.itemsSource.forEach(item => {
      // 選択行の付替ステータスが「提案前」の場合、コンテキストメニューを「商品提案」を活性させる
      if (item.caption === '商品提案' && this.dtg_FeatureRequestList.selectedItems[0].statusName === "提案前") {
        item.enabled = true;
      // 選択行の付替ステータスが「提案済み」の場合、コンテキストメニューの「履歴確認」を活性させる
      } else if (item.caption === '履歴確認' && this.dtg_FeatureRequestList.selectedItems[0].statusName === "提案済み") {
        item.enabled = true;
      } else {
        item.enabled = false;
      }
    });
  }
}